import {makeObservable, observable, action, computed} from "mobx";
import apiService from "../services/apiServices";
import {sortCubeMapImages} from "../utils";
import { CUBE_MAP_IMAGES, DEFOULT_IDLE_VIDEO } from "./constatns";
import { cacheService } from "../services/cacheService";

class ThreeCubeEnvStore {
    ended = false;
    cubeThreeVisible = false;
    transparentVideoUrl = '';
    cubeMapImages = [];
    cubeEnvId = 0;
    muted = false;
    meshPosition = {x: -5, y: 0, z: 15}
    meshScale = {
        video_scale_x: 1, 
        video_scale_y: 1, 
        video_scale_z: 1
    };
    cacheRoomEnv = {};
    receptionEnv = null;
    showCarousel = true;
    showPopup = false;
    showThreeJsPopup = false;
    panoramicPopup = false;
    cameraDefaultPosition = 0;
    popupStep = 1;
    hooryTokenFor360 = ""
    showMorePopup = false

    constructor() {
        makeObservable(this, {
            ended: observable,
            muted: observable,
            showMorePopup: observable,
            cubeThreeVisible: observable,
            transparentVideoUrl: observable,
            cubeMapImages: observable,
            cubeEnvId: observable,
            meshPosition: observable,
            meshScale: observable,
            cacheRoomEnv: observable,
            receptionEnv: observable,
            showCarousel: observable,
            showPopup: observable,
            showThreeJsPopup: observable,
            panoramicPopup: observable,
            cameraDefaultPosition: observable,
            popupStep: observable,
            hooryTokenFor360: observable,
            setOnEnded: action.bound,
            setSound: action.bound,
            setShowThreeCube: action.bound,
            setCubeEnvId: action.bound,
            setCubeEnv: action.bound,
            cleanUpEnvValues: action.bound,
            setReceptionEnv: action.bound,
            setShowCarousel: action.bound,
            setShowPopup: action.bound,
            setShowThreeJsPopup: action.bound,
            setPanoramicPopup: action.bound,
            setHooryTokenFor360: action.bound,
            setShowMorePopup: action.bound,
            hasReceptionRoom: computed,
        });
    }

    setShowMorePopup(bool) {
        this.showMorePopup = bool
    }

    setOnEnded(bool) {
        this.ended = bool;
    }
    setShowPopup(bool) {
        this.showPopup = bool;
    }
    setSound(bool) {
        this.muted = bool;
    }

    setShowThreeCube(bool) {
        this.cubeThreeVisible = bool;
    }

    setCubeEnvId(id) {
        if(this.cacheRoomEnv[id]){
            return this.setCubeEnv(this.cacheRoomEnv[id], id);
        }

        if (id) {
            apiService.getRoomByID(id, {jtx: "True"})
                .then(({data: {data}}) => {
                    if (data?.room_360) {
                        this.cameraDefaultPosition = data?.camera_default_position;
                        this.setHooryTokenFor360(data?.hoory_website_token);
                        this.setCubeEnv(data?.room_360, id);
                        this.cacheRoomEnv[id] = data?.room_360
                    }else{
                        this.setCubeEnvId(this.receptionEnv)
                    }
                });
        } else {
            this.cleanUpEnvValues();
        }
    }

    setCubeEnv(data, id) {
        const {pictures, video, position_and_rotation, video_scale_x, video_scale_y, video_scale_z} = data;
        this.transparentVideoUrl = video || DEFOULT_IDLE_VIDEO;
        if(position_and_rotation){
            const {position_x, position_y, position_z } = position_and_rotation;
            this.meshPosition = {x: position_x, y: position_y, z: position_z};
            this.meshScale = {
                video_scale_x, video_scale_y, video_scale_z
            };
        }
        this.cubeMapImages = sortCubeMapImages(pictures, CUBE_MAP_IMAGES);

        this.cubeEnvId = id;
    }

    setReceptionEnv(data){
        this.receptionEnv = data;
    }

    setShowCarousel(bool){
        this.showCarousel = bool;
    }

    cleanUpEnvValues() {
        this.meshPosition = {x: 0, y: 0, z: 0};
        this.cubeMapImages = [];
    }

    setShowThreeJsPopup(bool) {
        this.showThreeJsPopup = bool
    }

    setPanoramicPopup(bool, step=1){
        this.popupStep = step
        this.panoramicPopup = bool
    }

    setHooryTokenFor360(string) {
        this.hooryTokenFor360 = string
    }

    get hasReceptionRoom(){
        return this.receptionEnv === Number(cacheService.get('RoomId'))
    }
}

export const threeCubeEnvStore = new ThreeCubeEnvStore();


